import { Rebate } from "types/tire";
import { uuid } from "helpers/uuid";

interface Props {
  rebates: Rebate;
}
export const Rebates = ({ rebates }: Props) => {
    return (
    <div>
        <div className="ta-flex ta-flex-col md:ta-flex-row md:ta-gap-7 ta-items-center md:ta-justify-center">
          <div className="ta-mb-3">
            <img
              src={rebates.ImageUrl}
              alt="Rebates"
              className="ta-max-w-[283px]"
            />
          </div>
          <div>
            <h1 className="ta-text-2xl ta-font-bold">{rebates.Name}</h1>
            <p className="ta-text-xl">{rebates.Description}</p>
          </div>            
        </div>
        <div className="ta-mt-7">
            <a
                target={"noopener noreferrer"}
                href={rebates.PdfUrl}
                className="ta-block ta-w-full ta-rounded-[3px] ta-py-2 !ta-bg-primary ta-bg-none ta-font-bold ta-text-sm ta-text-center ta-text-white hover:ta-bg-[length:0px_0px]"
            >
                Download Rebate Form
                <span className="ta-sr-only">will open in a new window</span>
            </a>
        </div>
    </div>
  );
};
